import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';

import { useDispatch, useSelector } from 'react-redux';
import { addContactRole, removeContactRole } from 'bundles/apex/deals/form/store/deal/actions';

import { Button } from 'components/ui/button';
import { AddContactModal } from 'bundles/backoffice/contacts/add';
import { ContactRolesCard } from 'bundles/backoffice/contacts/card';

export default function DealContacts({ label, required, role }) {
  const [showAddModal, setShowAddModal] = useState(false);

  const deal = useSelector(state => state.deal);
  const features = useSelector(state => state.features);
  const dispatch = useDispatch();

  const contactRoles = deal.contactRoles.filter(contactRole => contactRole.role === role && !contactRole._destroy);

  const headerControls = <>
    <Button
      icon={faCirclePlus}
      label={`Add ${label}`}
      size="sm"
      variant="ghost"
      onClick={() => setShowAddModal(true)}
    />

    <AddContactModal
      allowTagging={features.crmTags}
      contactLabel={label}
      show={showAddModal}
      onAdd={contactRole => dispatch(addContactRole({ ...contactRole, role, roleLabel: label }))}
      onClose={() => setShowAddModal(false)}
    />
  </>;

  return (
    <div className="deal-form--full__card-wrapper">
      <ContactRolesCard
        allowContactEditing={false}
        contactLabel={label}
        contactRoles={contactRoles}
        features={features}
        header={label}
        headerControls={headerControls}
        inline
        required={required}
        onRemoveContactRole={contactRole => dispatch(removeContactRole(contactRole))}
      />
    </div>
  );
}

DealContacts.propTypes = {
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  role: PropTypes.string.isRequired,
};
